import { Button } from "@op/opds.opux";
import { IconPrint } from "@op/opds.opux-icons/action";
import { FormattedMessage } from "react-intl";
import { useReferenceNumbers } from "../../providers/ReferenceNumberProvider";
import DownloadButton from "./DownloadButton";

type ReferenceNumberCalculatorButtonsProps = {
  print: () => void;
};

const ReferenceNumberCalculatorButtons = ({
  print,
}: ReferenceNumberCalculatorButtonsProps) => {
  const { referenceNumbers } = useReferenceNumbers();
  const numbers = referenceNumbers.join("\r\n");
  const data = encodeURIComponent(numbers);

  return (
    <div className="buttons">
      <Button compact icon={IconPrint} onClick={print}>
        <FormattedMessage id="print" />
      </Button>
      <DownloadButton data={data} />
    </div>
  );
};

export default ReferenceNumberCalculatorButtons;
